import { useQuery } from '@tanstack/react-query';
import publicAxiosInstance from '../../../../constants/publicAxiosInstance';

export interface InviteUserDetails {
  userId: string;
  name: string;
  email: string;
  verified?: boolean;
}

export interface InviteUserDetailsResponse {
  data: InviteUserDetails;
  message?: string;
  status?: string;
  verified?: boolean;
}

const fetchInviteUserDetails = async (inviteToken: string): Promise<InviteUserDetailsResponse> => {
  const { data } = await publicAxiosInstance().post(`/newUsers/getUserInvitationDetails`, {
    inviteToken,
  });
  return {
    data: data?.data,
    message: data?.message,
    status: data?.status,
    verified: data?.data?.verified || data?.verified,
  };
};

export const useInviteUserDetails = (inviteToken: string) => {
  const {
    data: inviteUserDetailsResponse,
    isLoading: isInviteUserDetailsLoading,
    error: inviteUserDetailsError,
    refetch: refetchInviteUserDetails,
  } = useQuery({
    queryKey: ['inviteUserDetails', inviteToken],
    queryFn: () => fetchInviteUserDetails(inviteToken),
    enabled: !!inviteToken,
    staleTime: 0,
    retry: false,
  });
  return {
    inviteUserDetails: inviteUserDetailsResponse?.data,
    inviteUserDetailsVerified: inviteUserDetailsResponse?.verified,
    inviteUserDetailsMessage: inviteUserDetailsResponse?.message,
    inviteUserDetailsStatus: inviteUserDetailsResponse?.status,
    isInviteUserDetailsLoading,
    inviteUserDetailsError,
    refetchInviteUserDetails,
  };
};
